const initialState = () => {
    return {
        isRouteInfoComplete: false,
        isTransferTypeComplete: false,
        isAdditionalOptionsComplete: false,
        isContactComplete: false,
        routeInfo: {
            start_place: null,
            end_place: null,
            departure_date: null,
            departure_time: '',
            return_date: null,
            return_time: '',
            one_way: false,
            passengers: [],
        },

        code: null,
        searchParameters: null,
        transferType: null,
        transferTypeComment: null,
        additionalOptions: null,
        contact: {
            name: null,
            company_name: null,
            address: null,
            tax_number: null,
            phone: null,
            email: null,
            post_code: null,
            city: null,
            country: null,
            password: null,
            password_confirmation: null,
        },
        travelOptionComments: null,
        travelOptions: null,
    };
};

const state = initialState;

const getters = {
    getRouteInfo(state) {
        return state.routeInfo;
    },

    getCode(state) {
        return state.code;
    },

    getSearchParameters(state) {
        return state.searchParameters;
    },

    getTransferType(state) {
        return state.transferType;
    },

    getTransferTypeComment(state) {
        return state.transferTypeComment;
    },

    getTravelOptions(state) {
        return state.additionalOptions;
    },

    getContact(state) {
        return state.contact;
    },
    getTravelOptionComments: (state) => {
        return state.travelOptionComments;
    },

    getIsRouteInfoComplete(state) {
        return state.isRouteInfoComplete;
    },

    getIsTransferTypeComplete(state) {
        return state.isTransferTypeComplete;
    },

    getIsAdditionalOptionsComplete(state) {
        return state.isAdditionalOptionsComplete;
    },

    getIsContactComplete(state) {
        return state.isContactComplete;
    },
};

const mutations = {
    setCode(state, code) {
        state.code = code;
    },

    setSearchParameters(state, parameters) {
        state.searchParameters = parameters;
    },

    setTransferType(state, transferType) {
        state.transferType = transferType;
    },

    setTransferTypeComment(state, transferTypeComment) {
        state.transferTypeComment = transferTypeComment;
    },

    setTravelOptions(state, additionalOptions) {
        state.additionalOptions = additionalOptions;
    },

    setContact(state, contact) {
        state.contact = contact;
    },

    setTravelOptionComments(state, comments) {
        state.travelOptionComments = comments;
    },

    setIsRouteInfoComplete(state, value) {
        state.isRouteInfoComplete = value;
    },

    setIsTransferTypeComplete(state, value) {
        state.isTransferTypeComplete = value;
    },

    setIsAdditionalOptionsComplete(state, value) {
        state.isAdditionalOptionsComplete = value;
    },

    setIsContactComplete(state, value) {
        state.isContactComplete = value;
    },

    reset(state) {
        const initial = initialState();

        Object.keys(initial).forEach((key) => {
            state[key] = initial[key];
        });
    },
};

const actions = {
    setCode({ commit }, code ) {
        commit('setCode', code);
    },

    setSearchParameters({ commit }, parameters ) {
        commit('setSearchParameters', parameters);
    },

    setTransferType({ commit }, transferType ) {
        commit('setTransferType', transferType);
    },

    setTransferTypeComment({ commit }, transferTypeComment) {
        commit('setTransferTypeComment', transferTypeComment);
    },

    setTravelOptions({ commit }, additionalOptions) {
        commit('setTravelOptions', additionalOptions);
    },

    setContact({ commit }, contact) {
        commit('setContact', contact);
    },

    setTravelOptionComments({ commit }, comments) {
        commit('setTravelOptionComments', comments);
    },

    setIsRouteInfoComplete({ commit }, value) {
        commit('setIsRouteInfoComplete', value);
    },

    setIsTransferTypeComplete({ commit }, value) {
        commit('setIsTransferTypeComplete', value);
    },

    setIsAdditionalOptionsComplete({ commit }, value) {
        commit('setIsAdditionalOptionsComplete', value);
    },

    setIsContactComplete({ commit }, value) {
        commit('setIsContactComplete', value);
    },

    reset({ commit }) {
        commit('reset');
    },
};


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
